import { isDefined } from 'ts-utils';
import { StoreStateInternal } from '../store/Store';

const STORE_KEY = 'temp-store';

function persistStore(state: StoreStateInternal): void {
  try {
    localStorage.setItem(STORE_KEY, JSON.stringify(state));
  } catch (error) {
    console.error('StorePersistence.persist failed:', error);
    throw error; // Important to rethrow to ensure the error is not ignored in payment flows
  }
}

function getPersistedStore(): StoreStateInternal | undefined {
  try {
    const state = localStorage.getItem(STORE_KEY);
    return isDefined(state) ? JSON.parse(state) : undefined;
  } catch (error) {
    console.error('StorePersistence.get failed:', error);
    return undefined;
  }
}

function clearPersistedStore(): void {
  try {
    localStorage.removeItem(STORE_KEY);
  } catch (error) {
    console.error('StorePersistence.clear failed:', error);
  }
}

export const StorePersistence = {
  persist: persistStore,
  get: getPersistedStore,
  clear: clearPersistedStore,
};
